import React from "react";

export const FailedIconLarge = (props) => {
  return (
    <>
      <svg
        width={90}
        height={90}
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx={45} cy={45} r={44.5} fill="#CF6679" stroke="#CF6679" />
        <path
          d="M27.0625 61.3597L62.2632 27.0176L27.0625 61.3597Z"
          fill="#CF6679"
        />
        <path
          d="M27.0625 61.3597L62.2632 27.0176"
          stroke="white"
          strokeWidth={6}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M27.4408 26.6618L61.8538 61.7556L27.4408 26.6618Z"
          fill="#CF6679"
        />
        <path
          d="M27.4408 26.6618L61.8538 61.7556"
          stroke="white"
          strokeWidth={6}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
